import React from "react";

/* Envelope — an email address. */
export const MailIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <rect x="2.75" y="4.75" width="18.5" height="14.5" rx="2.25"
          stroke="currentColor" strokeWidth="1.7" />
    <path d="M3.5 6.5l8.5 6 8.5-6"
          stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default MailIcon;
